<template>
  <div class="layout-tab-container">
    <layout-tab
      ref="layoutTab"
      :bannerTemplate="{
        api: {
          url: '/purchaser/mall/bannerBottom/getBannerBottom',
          type: 'get'
        },
        keys: {
          logoKey: 'logoUrl',
          linkKey: 'logoLink'
        }
      }"
      :defaultOpeneds="defaultOpeneds"
    >
      <template v-slot:header>
        <public-header></public-header>
      </template>
    </layout-tab>
    <side-fixed v-if="!$route.meta.hideSideFixed" type="fluid"></side-fixed>
    <!-- 系统公告 -->
    <SystemAnnouncement publishScope='mall' v-if="!$route.meta.noNotice"></SystemAnnouncement>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {LayoutTab} from 'fe-coms'
import SideFixed from '@/components/side-fixed/index.vue'
import PublicHeader from '@/components/mall-public-container/public-header'
import SystemAnnouncement from 'fe-coms/components/business/system-announcement/index.vue'

export default {
  name: 'layout-full',
  components: {
    LayoutTab,
    PublicHeader,
    SideFixed,
    SystemAnnouncement
  },
  computed: {
    ...mapState({
      applicationClassifyList: state => state.user.applicationClassifyList
    }),
    defaultOpeneds () {
      return this.applicationClassifyList.map(item => item.name)
    }
  },
  methods: {
    // 对外接口 - 由于layout-tab多包裹了一层，所以此方法透传
    back () {
      this.$refs.layoutTab?.back()
    },
    // 对外接口 - 方法透传
    reset () {
      this.$refs.layoutTab?.reset()
    },
    // 对外接口 - 方法透传
    setPreRoute (current, prev) {
      this.$refs.layoutTab?.setPreRoute(current, prev)
    }
  }
}
</script>

<style lang="scss" scoped>
  .layout-tab-container {
    height: 100%;
  }
</style>
